import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { OnboardingLayout } from '../Layout';
import { Button } from '@/components/ui/Button';
import { ListItem } from '@/components/ui/ListItem';
import { Spinner } from '@/components/ui/Spinner';
import { IcEdit, IcTrash } from '@/components/ui/icons';
import { useDeleteFamilyMember, useFamily } from '@/api/queries/family';
import { paths } from '@/routes/paths';

export function OnboardingFamilyListPage(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const family = useFamily();
  const del = useDeleteFamilyMember();

  return (
    <OnboardingLayout back title={t('onboarding.family.list_title')}>
      {family.isLoading && <Spinner />}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {family.data?.map((m) => (
          <ListItem
            key={m.id}
            title={`${m.given_name} ${m.surname}`}
            subtitle={t(`family_member.role.${m.role}`)}
            trailing={
              <div style={{ display: 'flex', gap: 12 }}>
                <button aria-label="Edit" type="button" style={{ color: 'var(--color-accent-blue)' }}>
                  <IcEdit />
                </button>
                <button aria-label="Delete" type="button" onClick={() => del.mutate(m.id)} style={{ color: 'var(--color-danger)' }}>
                  <IcTrash />
                </button>
              </div>
            }
          />
        ))}
      </div>
      <Button block variant="inverted" onClick={() => navigate(paths.onboardingFamilyForm)}>
        + {t('onboarding.family.add')}
      </Button>
      <Button block size="lg" variant="ghost" onClick={() => navigate(paths.onboardingPaymentEmpty)}>
        {t('common.continue')}
      </Button>
    </OnboardingLayout>
  );
}
